import React from 'react';
import { FadeIn } from './FadeIn';
import { CheckCircle, Dumbbell, Utensils, FlaskConical, HeartPulse, Trophy, ClipboardList, BookOpen } from 'lucide-react';
export function Tomos() {
  const tomos = [{
    icon: <Dumbbell size={22} className="text-accent" data-id="element-347" />,
    title: 'Tomo 1',
    subtitle: 'Planes deportivos según objetivo',
    desc: 'Hipertrofia · pérdida de grasa · recomposición'
  }, {
    icon: <Utensils size={22} className="text-accent" data-id="element-348" />,
    title: 'Tomo 2',
    subtitle: 'Nutrición según deporte',
    desc: 'Fuerza · resistencia · deportes de equipo'
  }, {
    icon: <FlaskConical size={22} className="text-accent" data-id="element-349" />,
    title: 'Tomo 3',
    subtitle: 'Suplementación deportiva avanzada',
    desc: 'Evidencia · dosis · protocolos de uso'
  }, {
    icon: <HeartPulse size={22} className="text-accent" data-id="element-350" />,
    title: 'Tomo 4',
    subtitle: 'Hormonas y fármacos en culturismo',
    desc: 'Efectos · riesgos · abordaje nutricional'
  }, {
    icon: <Trophy size={22} className="text-accent" data-id="element-351" />,
    title: 'Tomo 5',
    subtitle: 'Peak week y competencia',
    desc: 'Carga de hidratos · agua · puesta a punto'
  }, {
    icon: <ClipboardList size={22} className="text-accent" data-id="element-352" />,
    title: 'Tomo 6',
    subtitle: 'Casos clínicos y consulta rápida',
    desc: 'Resolución · ajustes · ejemplos reales'
  }];
  const incluye = {
    left: ['Plantillas de planes deportivos listas para usar', 'Protocolos de suplementación por disciplina', 'Anamnesis deportiva completa', 'Checklists de evaluación corporal'],
    right: ['Registros de evolución y rendimiento', 'Guiones para explicar estrategias al paciente', 'Formatos reutilizables para distintos atletas', 'Herramientas pensadas para consulta real']
  };
  return <section className="pt-4 pb-8" data-id="element-353">
      <div className="max-w-4xl mx-auto px-3" data-id="element-354">
        <FadeIn className="text-center mb-5" data-id="element-355">
          <h2 className="font-display text-2xl md:text-4xl font-bold text-white mb-1" data-id="element-356">
            Lo que <span className="text-accent" data-id="element-357">recibís</span>
          </h2>
          <p className="text-sm text-white/50 font-medium flex items-center justify-center gap-1.5" data-id="element-358">
            <BookOpen size={16} className="text-accent" data-id="element-359" />
            Tu biblioteca clínica práctica — 6 tomos
          </p>
        </FadeIn>

        <FadeIn data-id="element-360">
          <div className="grid grid-cols-2 md:grid-cols-3 gap-3 md:gap-4" data-id="element-361">
            {tomos.map((tomo, idx) => <div key={idx} className="flex flex-col items-center text-center group" data-id="element-362">
                <div className="w-20 h-26 md:w-24 md:h-32 rounded-[50%] border-[3px] border-accent/40 bg-accent/5 flex flex-col items-center justify-center mb-2 group-hover:border-accent/60 group-hover:bg-accent/10 group-hover:scale-105 transition-all duration-300" data-id="element-363">
                  <span className="mb-0.5" data-id="element-364">{tomo.icon}</span>
                  <span className="text-[9px] font-bold text-accent uppercase tracking-wider" data-id="element-365">
                    {tomo.title}
                  </span>
                </div>
                <h4 className="text-xs md:text-sm font-bold text-white mb-0.5 leading-tight" data-id="element-366">
                  {tomo.subtitle}
                </h4>
                <p className="text-[10px] md:text-xs text-white/50 leading-snug" data-id="element-367">
                  {tomo.desc}
                </p>
              </div>)}
          </div>
        </FadeIn>

        <FadeIn className="mt-8" data-id="element-368">
          <div className="bg-surface border border-accent/20 rounded-2xl p-5 md:p-8" data-id="element-369">
            <h3 className="text-center text-xl md:text-2xl font-bold text-white mb-5" data-id="element-370">
              Cada tomo incluye:
            </h3>
            <div className="grid grid-cols-1 md:grid-cols-2 gap-x-8 gap-y-3" data-id="element-371">
              <ul className="space-y-3" data-id="element-372">
                {incluye.left.map((item, idx) => <li key={idx} className="flex items-start gap-2.5" data-id="element-373">
                    <CheckCircle size={18} className="text-green-500 shrink-0 mt-0.5" data-id="element-374" />
                    <span className="text-white/80 text-sm md:text-base" data-id="element-375">
                      {item}
                    </span>
                  </li>)}
              </ul>
              <ul className="space-y-3" data-id="element-376">
                {incluye.right.map((item, idx) => <li key={idx} className="flex items-start gap-2.5" data-id="element-377">
                    <CheckCircle size={18} className="text-green-500 shrink-0 mt-0.5" data-id="element-378" />
                    <span className="text-white/80 text-sm md:text-base" data-id="element-379">
                      {item}
                    </span>
                  </li>)}
              </ul>
            </div>
          </div>
        </FadeIn>
      </div>
    </section>;
}